import React from 'react';

import { performCatalogSearch } from 'app/actions/SearchActions';
import BrowseSearchPage from 'app/components/browse/search';
import { FILTERABLE_DISPLAY_BIB_GRID_LIMIT } from 'app/constants/BrowseConstants';
import connectRoute from 'app/routes/connectRoute';

const getRouteData = ({ dispatch, location }) => {
  const { query, searchType, ...filters } = Object.fromEntries(new URLSearchParams(location.search));

  return [dispatch(performCatalogSearch({ limit: FILTERABLE_DISPLAY_BIB_GRID_LIMIT, query, searchType, ...filters }))];
};

const BrowseSearchPageRoute = () => {
  return <BrowseSearchPage />;
};

export default connectRoute(BrowseSearchPageRoute, { getRouteData });
